module.exports = __webpack_public_path__ + "img/fork-knife.6358b4c0.svg";